export function formatAppVersion(appVersion: string, gitSha = ''): string {
  const versionLabel = appVersion === 'main' && gitSha
    ? `${appVersion}+${gitSha.slice(0, 7)}`
    : appVersion;

  return versionLabel.startsWith('v') ? versionLabel : `v${versionLabel}`;
}
